import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid } from "recharts";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { CardContent } from "@/core/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/core/components/ui/chart";
import { useGetBusinessWeeklyStats } from "@/business/query";
import { useBusiness } from "@/core/business";
import { DashboardPaneCard } from "./dashboard-pane-card";

const chartConfig = {
  total_signup_count: {
    label: "Total Signups",
    color: "#0077D9",
  },
  attributed_signup_count: {
    label: "Attributed Signups",
    color: "#00BDCF",
  },
  automatic_signup_count: {
    label: "Unattributed Signups",
    color: "#FF7F3E",
  },
};

const SignupsChartPane = React.memo(() => {
  const { businessId } = useBusiness();
  const { data, isLoading } = useGetBusinessWeeklyStats(businessId);

  if (isLoading) {
    return (
      <DashboardPaneCard className="flex flex-col" title="Sign-ups">
        <LoadingSpinner flexHeight style={{ aspectRatio: "16/9" }} />
      </DashboardPaneCard>
    );
  }

  return (
    <DashboardPaneCard title="Sign-ups">
      <CardContent className="p-0 pr-6">
        <ChartContainer config={chartConfig}>
          <LineChart
            accessibilityLayer
            data={data}
            margin={{
              left: 12,
              right: 12,
              top: 10,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="week_range"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              height={60}
              tickFormatter={(value) => value.split(" - ")[0]}
            />
            <YAxis
              width={40}
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              allowDecimals={false}
            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent indicator="line" />}
            />
            {/* <Line
              dataKey="total_signup_count"
              type="monotone"
              stroke={chartConfig.total_signup_count.color}
              strokeWidth={2}
            /> */}
            <Line
              dataKey="attributed_signup_count"
              type="monotone"
              stroke={chartConfig.attributed_signup_count.color}
              strokeWidth={2}
            />
            <Line
              dataKey="automatic_signup_count"
              type="monotone"
              stroke={chartConfig.automatic_signup_count.color}
              strokeWidth={2}
            />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </DashboardPaneCard>
  );
});

export default SignupsChartPane;
